@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";

// Variables para gaps y tamaños
$gap-main: var(--spacing-gap-xl);
$gap-secondary: var(--spacing-gap-m);
$max-button-width: 300px;
$commit-message-height: 65px;

// Mixin para grid con gap
@mixin grid-gap($gap) {
  display: grid;
  gap: $gap;
}

:host {
  display: grid;
  block-size: 100%;
}

.main-container {
  @include grid-gap($gap-main);
  grid-template-rows: max-content 1fr max-content;
  overflow: auto;

  .local-changes-container {
    @include grid-gap($gap-secondary);
    grid-template-rows: max-content max-content max-content 1fr;
    padding-inline: 0;
  }
  .remote-changes-container {
    @include grid-gap($gap-secondary);
    grid-template-rows: max-content max-content 1fr;
    padding-inline: 0;
  }
}

.dialog-footer-with-border.open-window-container {
  --dialog-footer-justify-content: flex-start;
}

// WA: Loader animation workaround, ideally move to mercury
.loader-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

// WA: Avoid scrollbar flickering for empty state
.empty-state {
  overflow: hidden;
}

.giu-static-pill-icon-and-text {
  background-color: var(--color-accent-surface-elevation-2);
}

.tab {
  overflow: auto;
  row-gap: $gap-secondary;

  &.border-style-none {
    border-style: none;
  }
}

.empty-state-button {
  inline-size: 100%;
  max-inline-size: $max-button-width;
}

.button-tertiary {
  &.team-dev-button {
    text-decoration: underline;
    color: var(--color-text-neutral-default);
  }

  &.refresh-button,
  &.open-full-dialog-button {
    justify-self: start;
  }
}

.commit-message-textarea {
  block-size: $commit-message-height;
}

.empty-state-container {
  @include grid-gap($gap-secondary);
  grid-template-rows: max-content max-content;
}

// WA: These styles display the tree as a flat list while preserving tree functionality.

// Style for change-item header
ch-tree-view-render::part(change-item item__header) {
  padding-inline-start: 0;
}

// Style for root-item header
ch-tree-view-render::part(root-item item__header) {
  padding-inline-start: 0;
  font-weight: var(--font-style-semi-bold);
  font-size: var(--font-size-body-s);
  line-height: var(--line-height-tight);
}

.version-pill {
  @include ellipsis;
}

.giu-static-pill-icon-and-text.version {
  grid-auto-columns: unset;
}
